import { User } from '@angular/fire/auth';
import { customClaims, redirectLoggedInTo, redirectUnauthorizedTo } from '@angular/fire/auth-guard';
import { filter, map, Observable, pipe, UnaryFunction } from 'rxjs';
import { GLOBAL_PATHS } from '../constants/routing.consts';

export const redirectUnauthorizedToLogin = () => redirectUnauthorizedTo(GLOBAL_PATHS.LOGIN);

export const adminOnly: () => UnaryFunction<Observable<User | null>, Observable<boolean>> = () =>
  pipe(
    filter(Boolean),
    customClaims,
    map((claims) => {
      // Handle both array and object cases
      if (Array.isArray(claims)) {
        return false; // or handle array case as needed
      }
      return claims?.admin || false;
    }),
    map(Boolean),
  );

export const redirectLoggedInToTrainingPlanner = () => redirectLoggedInTo(GLOBAL_PATHS.DEFAULT_LANDING);
